<template>
  <footer class="bg-black relative">
    <div class="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-echoes-border-light to-transparent"></div>
    <div class="max-w-7xl mx-auto flex items-center px-4 sm:px-6 lg:px-8">
      
      <!-- Main Footer Content -->
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12 py-12 lg:py-16">
        
        <!-- Brand Section -->
        <div class="col-span-1 sm:col-span-2 lg:col-span-1">
          <div class="flex flex-col h-full">
            <!-- Logo -->
            <div class="mb-6">
              <router-link class="inline-flex items-center group" to="/" aria-label="Portex">
                <div class="text-2xl font-bold text-white group-hover:text-stone-200 transition-colors duration-200">
                  PortexAI<span class="bg-gradient-to-r from-white/50 to-white/80 bg-clip-text text-transparent">Labs</span>
                </div>
              </router-link>
            </div>
            
            <div class="text-sm text-stone-400">
            &copy; {{ currentYear }} Portex AI Inc. All rights reserved.
          </div>
            
            <!-- Social Links -->
            <div class="mt-auto">
              <div class="flex items-center space-x-4">
                <a 
                  class="group flex items-center justify-center w-10 h-10 transition-all duration-200" 
                  href="https://twitter.com/portexai" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  aria-label="Follow us on Twitter"
                >
                  <svg class="fill-current hover:text-[#FE3E01] transition-all duration-200" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                    <path d="m13.063 9 3.495 4.475L20.601 9h2.454l-5.359 5.931L24 23h-4.938l-3.866-4.893L10.771 23H8.316l5.735-6.342L8 9h5.063Zm-.74 1.347h-1.457l8.875 11.232h1.36l-8.778-11.232Z" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>

        <!-- Company Section -->
        <div class="col-span-1">
          <h6 class="text-sm font-semibold text-white uppercase tracking-wider mb-4">Company</h6>
          <ul class="space-y-3">
            <li>
              <a 
                class="text-sm text-stone-300 hover:text-white transition-colors duration-200 inline-flex items-center group" 
                href="#0"
              >
                <span>Careers</span>
                <span class="ml-2 text-xs text-stone-500 group-hover:text-stone-400">Coming Soon</span>
              </a>
            </li>
            <li>
              <a 
                class="text-sm text-stone-300 hover:text-white transition-colors duration-200" 
                href="mailto:hello@portexai.com"
              >
                Contact Us
              </a>
            </li>
          </ul>
        </div>

        <!-- Resources Section -->
        <div class="col-span-1">
          <h6 class="text-sm font-semibold text-white uppercase tracking-wider mb-4">Resources</h6>
          <ul class="space-y-3">
            <li>
              <a 
                class="text-sm text-stone-300 hover:text-white transition-colors duration-200 inline-flex items-center group" 
                href="https://docs.portexai.com/" 
                target="_blank"
                rel="noopener noreferrer"
              >
                Documentation
              
                <i class="uil uil-arrow-up-right ml-1.5 opacity-0 group-hover:opacity-100 transition-opacity"></i>
              </a>
            </li>
            <li>
              <a 
                class="text-sm text-stone-300 hover:text-white transition-colors duration-200 inline-flex items-center group" 
                href="https://research.portexai.com/" 
                target="_blank"
                rel="noopener noreferrer"
              >
                Research
                <i class="uil uil-arrow-up-right ml-1.5 opacity-0 group-hover:opacity-100 transition-opacity"></i>
              </a>
            </li>
            <li>
              <a 
                class="text-sm text-stone-300 hover:text-white transition-colors duration-200" 
                href="mailto:hello@portexai.com"
              >
                Report an Issue
              </a>
            </li>
          </ul>
        </div>

        <!-- Legal Section -->
        <div class="col-span-1">
          <h6 class="text-sm font-semibold text-white uppercase tracking-wider mb-4">Legal</h6>
          <ul class="space-y-3">
            <li>
              <router-link 
                class="text-sm text-stone-300 hover:text-white transition-colors duration-200" 
                to="/tou"
              >
                Terms of Use
              </router-link>
            </li>
            <li>
              <router-link 
                class="text-sm text-stone-300 hover:text-white transition-colors duration-200" 
                to="/privacy"
              >
                Privacy Policy
              </router-link>
            </li>
            <li>
              <router-link 
                class="text-sm text-stone-300 hover:text-white transition-colors duration-200" 
                to="/cookies"
              >
                Cookie Policy
              </router-link>
            </li>
          </ul>
        </div>

      </div>

    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  }
}
</script> 